import slider_temp_image from './assests/images/slider_image.png';
import shirt_image from './assests/images/shirt_img.jpg';
export const sliderItems = [
    
    {
        id: 1,
        img: "https://www.pngarts.com/files/16/Emilia-Clarke-PNG-Background-Image.png",
        title: "H&M SALE ",
        desc: "35% OFF FOR NEW COMMERS",
        bg: "#4c4c52"
    },
    {
      id: 2,
      img: "https://www.pngarts.com/files/12/Millie-Bobby-Brown-PNG-Pic.png",
      title: "Zara Sale",
      desc: "GET BEST ZARA CLOHTES AT 30% OFF",
      bg: "#cb0000"
  },
  {
    id: 3,
    img: slider_temp_image,
    title: "New Year Sale",
    desc: "GET BEST COTTON CLOTHES OF LUXORY BRANDS AT 20% OFF",
    bg: "#1f76aa"
},
]
export const categories = [
    {
        id: 1,
        img: shirt_image,
        title:"SHIRT STYLE!",
        categorie:'shirt'
    },
    {
        id: 2,
        img: "https://img.faballey.com/images/Product/ICO00015Z/1.jpg",
        title:"LOUNGWEAR LOVE!",
        categorie:'loungwear'
    },
    {
        id: 3,
        img: "https://images.unsplash.com/photo-1612096536102-93f503aa2419?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80",
        title:"JACKETS!",
        categorie:'jacket'
    }
]
export const popularProducts = [
    {
        id:1,
        img:"https://d3o2e4jr3mxnm3.cloudfront.net/Mens-Jake-Guitar-Vintage-Crusher-Tee_68382_1_lg.png",
      },
      {
        id:2,
        img:"https://www.pngarts.com/files/1/Women-Leather-Jacket-PNG-Pic.png",
      },
      {
        id:3,
        img:"https://www.pngarts.com/files/3/Clothing-PNG-Pic.png",
      },
      {
        id:4,
        img:"https://i.ibb.co/S6qMxwr/jean.jpg",
      },
      {
        id:5,
        img:"https://images.ctfassets.net/5gvckmvm9289/3BlDoZxSSjqAvv1jBJP7TH/65f9a95484117730ace42abf64e89572/Noissue-x-Creatsy-Tote-Bag-Mockup-Bundle-_4_-2.png",
      },
      {
        id:6,
        img:"https://d3o2e4jr3mxnm3.cloudfront.net/Rocket-Vintage-Chill-Cap_66374_1_lg.png",
      },
      {
        id:7,
        img:"https://www.pngarts.com/files/9/Black-Hoodie-Front-PNG-Transparent-Photo.png",
      },
      {
        id:8,
        img:"https://www.pngarts.com/files/3/Women-Jacket-PNG-High-Quality-Image.png",
      }
]

